import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useModifyOldPassword } from "../../lib/queries/queriesAndMutations.js";
import { changeOldPasswordSchema } from "../../lib/validation/index.js";
import CustomFormInput from "../../ui/CustomFormInput/index.js";
import PaymentButton from "../../ui/PaymentButton.jsx";
import Cookies from "js-cookie";

const ChangeOLdPasswordPage = () => {
  const navigate = useNavigate();

  const { mutateAsync: modifyOldPassword, isPending } = useModifyOldPassword();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { otp: "", new_password: "", new_password2: "" },
    resolver: zodResolver(changeOldPasswordSchema),
  });

  const processForm = async (data) => {
    try {
      const response = await modifyOldPassword(data);
      if (response.status === 201 || response.status === 200) {
        toast.success("رمز عبور مشا با موفقیت تغییر یافت");
        Cookies.remove("token");
        navigate("/login");
      }
    } catch (error) {
      console.error("ConfirmNewPasswordPage", error);
    }
  };

  return (
    <>
      <p className="text-[#7f7f7f] text-[16px] mb-1  font-bold w-full  mt-8">
        جهت تغییر رمز عبور حساب کاربری خود رمز عبور قدیمی خود را وارد نمایید.
      </p>

      <form
        onSubmit={handleSubmit(processForm)}
        className="flex flex-col gap-4 w-full max-w-[390px] mx-auto "
      >
        <CustomFormInput
          tabIndex={"8"}
          control={control}
          name={"otp"}
          label={"پیامک ارسالی"}
          type={"text"}
          isPassword={true}
          errors={errors.otp}
        />
        <CustomFormInput
          tabIndex={"8"}
          control={control}
          name={"new_password"}
          label={"رمز عبور جدید"}
          type={"text"}
          isPassword={true}
          errors={errors.new_password}
        />
        <CustomFormInput
          tabIndex={"8"}
          control={control}
          name={"new_password2"}
          label={"تکرار رمز عبور"}
          type={"text"}
          isPassword={true}
          errors={errors.new_password2}
        />

        <PaymentButton
          text={" ویرایش رمز عبور"}
          type={"submit"}
          isPending={isPending}
        />
      </form>
    </>
  );
};

export default ChangeOLdPasswordPage;

// import React, { useEffect, useState } from "react";
// import Cookies from "js-cookie";
// import { useNavigate } from "react-router-dom";

// import RequestConfig from "../mini_components/RequestConfig";
// import "react-toastify/dist/ReactToastify.css";
// import { Bounce, toast } from "react-toastify";
// import personWithIcon from "../assets/images/person-with-phone.png";
// import PaymentButton from "../ui/PaymentButton";
// import Loader from "../shared/Loader";
// import { handleErrorApi } from "../utils/utils";

// function ForgetPass() {
//   const [code, setCode] = useState("");
//   const [Pass, setPass] = useState("");
//   const [ConfirmPass, setConfirmPass] = useState("");
//   const [isCodeSent, setIsCodeSent] = useState(false);
//   const [OldPassword, setOldPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   const verifyOtp = () => {
//     setLoading(true);
//     const raw = JSON.stringify({
//       otp: code,
//       new_password: Pass,
//       new_password2: ConfirmPass,
//       old_password: OldPassword,
//     });
//     RequestConfig.post(`/users/password/update/`, raw)
//       .then((response) => {
//         if (response.status === 200) {
//           setLoading(false);
//           toast.success("رمز عبور شما با موفقیت تغییر یافت .");
//           Cookies.remove("token");
//           navigate("/");
//         }
//       })
//       .catch((err) => {
//         //console.log(err);
//         setError(err);
//         setLoading(true);
//         const errorMessage = err.response?.data?.detail || err;

//         toast.error(`خطا: ${errorMessage}`, {
//           position: "bottom-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "dark",
//           transition: Bounce,
//         });
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   const sendOtp = () => {
//     setLoading(true);
//     const raw = JSON.stringify({
//       old_password: OldPassword,
//     });
//     RequestConfig.post(`/users/password/update/otp/send/`, raw)
//       .then((response) => {
//         if (response.status === 200) {
//           setLoading(false);
//           setIsCodeSent(true);
//           toast.success("درخواست شما با موفقیت ثبت شد");
//         }
//       })
//       .catch((err) => {
//         handleErrorApi(err)

//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   return (
//     <div className="max-w-[90vw] w-fit min-w-[20vw] bg-white m-auto p-4 rounded-lg flex flex-col  gap-4">
//     <img src={personWithIcon} alt="" className=" max-h-[400px]"></img>

//     {loading && (
//       <div className="w-full h-full flex justify-center items-center min-h-[400px] ">
//       <Loader />
//     </div>
//     )}
//     {!loading && (
//       <>
//         <p>
//           جهت تغییر رمز عبور حساب کاربری خود رمز عبور قدیمی خود را وارد
//           نمایید.
//         </p>

//         <form className="flex flex-col gap-2 w-full ">
//           {isCodeSent && (
//             <>
//               <PasswordValidation />
//               <input
//                 type="text"
//                 className="h-[52px] px-4 outline-none rounded-v-md w-full border-[1px] border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
//                 placeholder="کد ارسال شده به تلفن همراه"
//                 aria-label="کد ارسال شده به تلفن همراه"
//                 onChange={(e) => setCode(e.target.value)}
//               />
//               <input
//                 type="text"
//                 className="h-[52px] px-4 outline-none rounded-v-md w-full border-[1px] border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
//                 placeholder="رمز عبور جدید"
//                 aria-label="رمز عبور جدید"
//                 onChange={(e) => setPass(e.target.value)}
//               />
//               <input
//                 type="text"
//                 className="h-[52px] px-4 outline-none rounded-v-md w-full border-[1px] border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
//                 placeholder="تکرار رمز عبور جدید"
//                 aria-label="تکرار رمز عبور جدید"
//                 onChange={(e) => setConfirmPass(e.target.value)}
//               />
//               <button
//                 onClick={verifyOtp}
//                 type="submit"
//                 className="text-[#FFFFFF] bg-[#39A78E] hover:bg-[#2A7A67] p-2 rounded mt-4"
//               >
//                 ویرایش رمز عبور
//               </button>
//             </>
//           )}
//           {!isCodeSent && (
//             <>
//               <input
//                 type="text"
//                 className="h-[52px] px-4 outline-none rounded-v-md w-full border-[1px] border-neutral-30 disabled:bg-neutral-10 disabled:border-none mb-4"
//                 placeholder="رمز عبور قدیمی"
//                 aria-label="رمز عبور قدیمی"
//                 onChange={(e) => setOldPassword(e.target.value)}
//               />
// <PaymentButton
//   text={"  ارسال کد احراز هویت"}
//   onClick={sendOtp}

// />
//             </>
//           )}
//         </form>
//       </>
//     )}
//   </div>
//   );
// }

// export default ForgetPass;

// const PasswordValidation = () => {
//   const validationRules = [
//     "رمز عبور جدید می بایست حداقل 8 کاراکتر باشد",
//     "رمز عبور جدید می بایست حداکثر 20 کاراکتر باشد",
//     "رمز عبور جدید می بایست حداقل دارای یک حرف بزرگ انگلیسی باشد",
//     "رمز عبور جدید می بایست حداقل دارای یک حرف کوچک انگلیسی باشد",
//     "رمز عبور جدید می بایست حداقل دارای یک عدد باشد",
//     "رمز عبور جدید نمی تواند شامل حروف غیر انگلیسی باشد",
//     "رمز عبور جدید می بایست حداقل دارای یک کاراکتر خاص باشد",
//   ];

//   return (
//     <div className=" text-[11px]">
//       {validationRules.map((rule, index) => (
//         <div key={index} className="text-zinc-400 font-semibold ">
//           {rule}
//         </div>
//       ))}
//     </div>
//   );
// };
